class ProductAction extends HTMLElement {
  constructor() {
    super();
    this.iconPlus = this.querySelector(".plus");
    this.iconMinus = this.querySelector(".minus");
    this.quantityInput = this.querySelector(".quantity-input");
    this.hiddenInputs = document.querySelectorAll(".pop-cart-id");
    this.buyButton = this.querySelector(".caorusole-slider-buy-button");
    this.form = this.closest(".shopify-product-form");
    this.formInside = this.querySelector(".caorusole-slider-add-to-cart-form");
    this.cartType = "ajax";
  }

  connectedCallback() {
    this.ADD_TO_CART = new Event("add-to-cart");
    this.buyButton.addEventListener("click", (event) => {
      event.preventDefault();

      let id = document.querySelector(".product-options__option.selected")
        .dataset.id;
      this.hiddenInputs.forEach((input) => {
        input.value = id;
      });

      let body;

      if (this.formInside) {
        body = this._serializeForm(this.formInside);
      } else {
        body = this._serializeForm(this.form);
      }

      fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        body,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        method: "POST",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.className = "alert alert--error";
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
            if (this.cartType == "page") {
              if (
                document.getElementById("product-page-form-error-cart-alert")
              ) {
                document
                  .getElementById("product-page-form-error-cart-alert")
                  .remove();
              }
              alert.style.marginTop = "1em";
              alert.style.marginBottom = "0";
              alert.id = "product-page-form-error-cart-alert";
              this.form.parentElement.append(alert);
              return false;
            }
            return fetch("?section_id=helper-cart");
          } else {
            if (this.cartType == "page") {
              document.location.href = KROWN.settings.routes.cart_url;
              return false;
            } else {
              return fetch("?section_id=helper-cart");
            }
          }
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          if (alert != "") {
            document.getElementById("AjaxCartForm").querySelector("form");
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-count]"
              ).textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-total]"
              ).textContent;
            });

          document.getElementById("site-cart-sidebar").show();
          if (document.getElementById("cart-recommendations-sidebar")) {
            document
              .getElementById("cart-recommendations-sidebar")
              .generateRecommendations();
          }

          setTimeout(() => {
            document
              .querySelector("#site-cart-sidebar [data-js-close]")
              .focus();
          }, 200);

          // a11y
          if (document.getElementById("screen-reader-info")) {
            document.getElementById(
              "screen-reader-info"
            ).innerText = `${KROWN.settings.locales.cart_announcement}`;
            setTimeout(() => {
              document.getElementById("screen-reader-info").innerText = "";
            }, 1000);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });

    this.iconPlus.addEventListener("click", (event) => {
      let quantity = document.querySelector(".product-options__option.selected")
        .dataset.quantity;

      if (this.quantityInput.value + 1 <= quantity) {
        this.quantityInput.value = parseInt(this.quantityInput.value) + 1;
        this.hiddenInputs.forEach(
          (input) => (input.dataset.quantity = this.quantityInput.value)
        );
        console.log("THIS QUANTITY INPUT VALUE -> ", this.quantityInput.value);

        this.form.action = `/cart/add?quantity=${this.quantityInput.value}`;

        if (this.formInside) {
          this.formInside.action = `/cart/add?quantity=${this.quantityInput.value}`;
        }
      } else {
        document.querySelectorAll(".atc-all-selected").forEach((msg) => {
          msg.style.display = "block";
        });
        setTimeout(() => {
          document.querySelectorAll(".atc-all-selected").forEach((msg) => {
            msg.style.display = "none";
          });
        }, 3000);
      }
    });

    this.iconMinus.addEventListener("click", (event) => {
      if (this.quantityInput.value >= 2) {
        this.quantityInput.value--;
        this.hiddenInputs.forEach(
          (input) => (input.dataset.quantity = this.quantityInput.value)
        );
        this.form.action = `/cart/add?quantity=${this.quantityInput.value}`;

        if (this.formInside) {
          this.formInside.action = `/cart/add?quantity=${this.quantityInput.value}`;
        }
      }
    });
  }

  _serializeForm(form) {
    let arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      console.log("SERIALIZE FIELD -> ", field);
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  }
}
customElements.define("product-action", ProductAction);

let optionsContainer = document.querySelectorAll(".product-options__options");

optionsContainer.forEach((options) => {
  options.querySelectorAll(".product-options__option").forEach((option) => {
    option.addEventListener("click", (event) => {
      event.stopPropagation();
      let data = event.target.getAttribute("data-value");

      document
        .querySelectorAll(".pop-custom-pdp-wrapper .product-options__title")
        .forEach((label) => {
          let labelValue = label.innerText.split(": ")[0];
          label.innerText = `${labelValue}: ${data}`;
        });

      document.querySelectorAll(".product-options__option").forEach((item) => {
        if (item.dataset.id != option.dataset.id) {
          item.classList.remove("selected");
        } else {
          item.classList.add("selected");
        }
      });

      option.classList.add("selected");

      document.querySelectorAll(".pop-gallery-container").forEach((gallery) => {
        if (gallery.getAttribute("data-variant") == data)
          gallery.classList.add("active");
        else gallery.classList.remove("active");
      });

      document.querySelectorAll(".pop-var-details").forEach((details) => {
        if (details.getAttribute("data-variant") == data)
          details.classList.add("active");
        else details.classList.remove("active");
      });

      document.querySelectorAll(".variant-title-container").forEach((title) => {
        if (title.getAttribute("data-variant") == data)
          title.classList.add("active");
        else title.classList.remove("active");
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 989) {
    let gallerySwiper = new Swiper(".pop-gallery-container", {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".pop-slider-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    });
  }
});

let popBtnATC = document.querySelector("product-action button");
document.querySelectorAll(".product-options__option").forEach((option) => {
  option.addEventListener("click", () => {
    let available = option.dataset.instock;
    if (available == "false") {
      popBtnATC.disabled = true;
    } else {
      popBtnATC.disabled = false;
    }
  });
});
